import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={12}
    fill="none"
    {...props}
  >
    <path
      fill="var(--task-link-color)"
      d="M4.173 1 3 2.233l3.803 3.734L3.137 9.8l1.11 1.2L9 6.011 4.173 1Z"
    />
  </svg>
);
export default SvgComponent;
